/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'styles/blocks/sideOption.scss';
import UIGenericGlass from 'components/ThreeJs/assets/filter/elementsUI/UIGenericGlass';
import SpacerUIElement from 'components/ThreeJs/assets/filter/elementsUI/SpacerUIElement';
import GasUIElement from 'components/ThreeJs/assets/filter/elementsUI/GasUIElement';
import camelToDash from './camelToDash';

const GlassProductSideOption = ({ name, uiHandlerRef }) => {
	const { t } = useTranslation('configurationCategory');
	const dashKey = name ? camelToDash(name) : '';

	return (
		<div className="glass_product_selection">
			<label className="glass_product_category_label_v2" htmlFor={dashKey.concat('_input')}>
				{t(name)}
			</label>
			{dashKey === 'fire-resistant' || dashKey === 'middle-glass' || dashKey === 'outside-glass' ? (
				<UIGenericGlass
					isDisabled
					id={dashKey}
					uiHandlerRef={uiHandlerRef}
					defaultVisible={dashKey !== 'fire-resistant'}
				/>
			) : null}
			{dashKey === 'gas1' ? <GasUIElement id={dashKey} uiHandlerRef={uiHandlerRef} /> : null}
			{dashKey === 'spacer1' ? <SpacerUIElement id={dashKey} uiHandlerRef={uiHandlerRef} /> : null}
		</div>
	);
};

export default GlassProductSideOption;
